import { Routes } from '@angular/router';

import { AddcategoryComponent } from './addcategory/addcategory.component';
import { ViewcategoryComponent } from './viewcategory/viewcategory.component';
import {NgxPermissionsGuard } from 'ngx-permissions';

export const EcommerceRoutes: Routes = [
    {
    path: 'publication',
    children: [
      {
        path: 'addcategory',
        component: AddcategoryComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Ecommerce',
          urls: [{title: 'Category',url: '/ecommerce/addcategory'},{title: 'Add Category'}],
          permissions: 
          {
            only: ['29','XXX'],
            redirectTo: '/dashboard'
          }
        }
      },
      {
        path: 'editcategory',
        component: AddcategoryComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Ecommerce',
          urls: [{title: 'Category',url: '/ecommerce/addcategory'},{title: 'Edit Category'}],
          permissions: 
          {
            only: ['30','XXX'],
            redirectTo: '/dashboard'
          }
        }
      }
       ,
      {
        path: 'viewcategory',
        component: ViewcategoryComponent,
        canActivate:[NgxPermissionsGuard],
        data: {
          title: 'Ecommerce',
          urls: [{title: 'Category',url: '/ecommerce/viewcategory'},{title: 'View Category'}],
          permissions: 
          {
            only: ['32','XXX'],
            redirectTo: '/dashboard'
          }
        }
      }
    ]
    }
]


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/ecommerce/ecommerce.routing.ts